import * as ActionTypes from './ActionTypes';
import { createActionCreator } from '../utils/ActionUtils';


export const init = createActionCreator(ActionTypes.INIT);
export const destroy = createActionCreator(ActionTypes.DESTROY);

export const playerEventCanPlayThrough = createActionCreator(ActionTypes.PLAYER_EVENT_CAN_PLAY_THROUGH);
export const playerEventDurationChange = createActionCreator(ActionTypes.PLAYER_EVENT_DURATION_CHANGE);
export const playerEventEnded = createActionCreator(ActionTypes.PLAYER_EVENT_ENDED);
export const playerEventError = createActionCreator(ActionTypes.PLAYER_EVENT_ERROR);
export const playerEventFullscreenChange = createActionCreator(ActionTypes.PLAYER_EVENT_FULLSCREEN_CHANGE);
export const playerEventLoadedData = createActionCreator(ActionTypes.PLAYER_EVENT_LOADED_DATA);
export const playerEventPause = createActionCreator(ActionTypes.PLAYER_EVENT_PAUSE);
export const playerEventPlay = createActionCreator(ActionTypes.PLAYER_EVENT_PLAY);
export const playerEventPlaying = createActionCreator(ActionTypes.PLAYER_EVENT_PLAYING);
export const playerEventReady = createActionCreator(ActionTypes.PLAYER_EVENT_READY);
export const playerEventTimeUpdate = createActionCreator(ActionTypes.PLAYER_EVENT_TIME_UPDATE);
export const playerEventVolumeChange = createActionCreator(ActionTypes.PLAYER_EVENT_VOLUME_CHANGE);
export const playerEventWaiting = createActionCreator(ActionTypes.PLAYER_EVENT_WAITING);

export const hlsEventMediaAttached = createActionCreator(ActionTypes.HLS_EVENT_MEDIA_ATTACHED);
export const hlsEventLevelLoaded = createActionCreator(ActionTypes.HLS_EVENT_LEVEL_LOADED);
export const hlsEventManifestParsed = createActionCreator(ActionTypes.HLS_EVENT_MANIFEST_PARSED);
export const hlsEventLoadError = createActionCreator(ActionTypes.HLS_EVENT_LOAD_ERROR);
export const hlsFragChanged = createActionCreator(ActionTypes.HLS_FRAG_CHANGED);

export const receiveVideoSource = createActionCreator(ActionTypes.RECEIVE_VIDEO_SOURCE);
export const receiveMediaSource = createActionCreator(ActionTypes.RECEIVE_MEDIA_SOURCE);
export const receiveCDNTokenSource = createActionCreator(ActionTypes.RECEIVE_CDN_TOKEN_SOURCE);
export const receiveAccessToken = createActionCreator(ActionTypes.RECEIVE_ACCESS_TOKEN);
export const receiveVideoPlayerData = createActionCreator(ActionTypes.RECEIVE_VIDEO_PLAYER_DATA);
export const fetchVideoSourceError = createActionCreator(ActionTypes.FETCH_VIDEO_SOURCE_ERROR);
export const reconnectStream = createActionCreator(ActionTypes.RECONNECT_STREAM);

export const setCurrentTimeState = createActionCreator(ActionTypes.SET_CURRENT_TIME_STATE);
export const setDurationState = createActionCreator(ActionTypes.SET_DURATION_STATE);
export const setErrorState = createActionCreator(ActionTypes.SET_ERROR_STATE);
export const setFirstTimeState = createActionCreator(ActionTypes.SET_FIRST_TIME_STATE);
export const setLiveState = createActionCreator(ActionTypes.SET_LIVE_STATE);
export const setMuteState = createActionCreator(ActionTypes.SET_MUTE_STATE);
export const setPauseState = createActionCreator(ActionTypes.SET_PAUSE_STATE);
export const setPlayState = createActionCreator(ActionTypes.SET_PLAYING_STATE);
export const setPlayingState = createActionCreator(ActionTypes.SET_PLAYING_STATE);
export const setStartedState = createActionCreator(ActionTypes.SET_STARTED_STATE);
export const setVideoID = createActionCreator(ActionTypes.SET_VIDEO_ID);
export const startContent = createActionCreator(ActionTypes.START_CONTENT);
export const setVolumeState = createActionCreator(ActionTypes.SET_VOLUME_STATE);
export const setIsVolumeDraggingState = createActionCreator(ActionTypes.SET_VOLUME_DRAG_STATE);
export const setWaitingState = createActionCreator(ActionTypes.SET_WAITING_STATE);
export const setAdPlayingState = createActionCreator(ActionTypes.SET_AD_PLAYING_STATE);
export const setAdSlots = createActionCreator(ActionTypes.SET_AD_SLOTS);
export const setAdsReturnMidrollTimeState = createActionCreator(ActionTypes.SET_ADS_RETURN_MIDROLL_TIME_STATE);
export const setQueryParamTimecodeSeekedState = createActionCreator(ActionTypes.SET_QUERY_PARAM_TIMECODE_SEEKED_STATE);
export const setVideoProgressState = createActionCreator(ActionTypes.SET_VIDEO_PROGRESS_STATE);
export const setPlaybackURL = createActionCreator(ActionTypes.SET_PLAYBACK_URL);
export const setCurrentAd = createActionCreator(ActionTypes.SET_CURRENT_AD);
export const setCurrentAdPod = createActionCreator(ActionTypes.SET_CURRENT_AD_POD);
export const setCurrentAdEndTime = createActionCreator(ActionTypes.SET_CURRENT_AD_END_TIME);
export const setAdTimeRemaining = createActionCreator(ActionTypes.SET_AD_TIME_REMAINING);
export const setCurrentAdTimeRemaining = createActionCreator(ActionTypes.SET_CURRENT_AD_TIME_REMAINING);
export const setAdEndTime = createActionCreator(ActionTypes.SET_AD_END_TIME);
export const setAdClickHandler = createActionCreator(ActionTypes.SET_AD_CLICK_HANDLER);
export const clearCurrentAd = createActionCreator(ActionTypes.CLEAR_CURRENT_AD);
export const clearCurrentAdPod = createActionCreator(ActionTypes.CLEAR_CURRENT_AD_POD);
export const setStreamBlocked = createActionCreator(ActionTypes.SET_STREAM_BLOCKED);
export const retryPlainStream = createActionCreator(ActionTypes.RETRY_PLAIN_STREAM);


export const trackUserInteraction = createActionCreator(ActionTypes.TRACK_USER_INTERACTION);
export const trackVideoBuffering = createActionCreator(ActionTypes.TRACK_VIDEO_BUFFERING);
export const trackVideoComplete = createActionCreator(ActionTypes.TRACK_VIDEO_COMPLETE);
export const trackVideoStart = createActionCreator(ActionTypes.TRACK_VIDEO_START);
export const trackVideoPause = createActionCreator(ActionTypes.TRACK_VIDEO_PAUSE);
export const trackVideoProgress = createActionCreator(ActionTypes.TRACK_VIDEO_PROGRESS);
export const trackVideoFifty = createActionCreator(ActionTypes.TRACK_VIDEO_FIFTY);
export const trackPreroll = createActionCreator(ActionTypes.TRACK_PREROLL);
export const trackMidrollStart = createActionCreator(ActionTypes.TRACK_MIDROLL_START);
export const trackMidrollEnd = createActionCreator(ActionTypes.TRACK_MIDROLL_END);
export const trackPostrollStart = createActionCreator(ActionTypes.TRACK_POSTROLL_START);
export const trackPostrollEnd = createActionCreator(ActionTypes.TRACK_POSTROLL_END);


export const adsEventRequestComplete = createActionCreator(ActionTypes.ADS_EVENT_REQUEST_COMPLETE);
export const adsEventSlotStarted = createActionCreator(ActionTypes.ADS_EVENT_SLOT_STARTED);
export const adsEventSlotEnded = createActionCreator(ActionTypes.ADS_EVENT_SLOT_ENDED);
export const adsEventImpressionStarted = createActionCreator(ActionTypes.ADS_EVENT_IMPRESSION_STARTED);
export const adsEventImpressionEnded = createActionCreator(ActionTypes.ADS_EVENT_IMPRESSION_ENDED);
export const adsEventError = createActionCreator(ActionTypes.ADS_EVENT_ERROR);
export const adsEventClick = createActionCreator(ActionTypes.ADS_EVENT_CLICK);
export const adsStartPreroll = createActionCreator(ActionTypes.ADS_START_PREROLL);
export const adsPrerollEnd = createActionCreator(ActionTypes.ADS_PREROLL_END);
export const adsMidrollEnd = createActionCreator(ActionTypes.ADS_MIDROLL_END);
export const adsPostrollEnd = createActionCreator(ActionTypes.ADS_POSTROLL_END);
export const enableAds = createActionCreator(ActionTypes.ENABLE_ADS);
export const disableAds = createActionCreator(ActionTypes.DISABLE_ADS);


export const onDocumentMouseMove = createActionCreator(ActionTypes.ON_DOCUMENT_MOUSE_MOVE);
export const onDocumentMouseUp = createActionCreator(ActionTypes.ON_DOCUMENT_MOUSE_UP);
export const onShareControlClick = createActionCreator(ActionTypes.ON_SHARE_CONTROL_CLICK);
export const onShareControlClose = createActionCreator(ActionTypes.ON_SHARE_CONTROL_CLOSE);
export const onShareSocial = createActionCreator(ActionTypes.ON_SHARE_SOCIAL);
export const onCopyClick = createActionCreator(ActionTypes.ON_COPY_CLICK);
export const onTimecodeSelectionChange = createActionCreator(ActionTypes.ON_TIMECODE_SELECTION_CHANGE);
export const onTimecodeInputChange = createActionCreator(ActionTypes.ON_TIMECODE_INPUT_CHANGE);
export const onVolumeSliderMouseDown = createActionCreator(ActionTypes.ON_VOLUME_SLIDER_MOUSE_DOWN);
export const onVolumeControlMouseOut = createActionCreator(ActionTypes.ON_VOLUME_CONTROL_MOUSE_OUT);
export const onVolumeControlMouseOver = createActionCreator(ActionTypes.ON_VOLUME_CONTROL_MOUSE_OVER);
export const updateVolumeFromDrag = createActionCreator(ActionTypes.UPDATE_VOLUME_FROM_DRAG);



// WEBPACK FOOTER //
// ./src/actions/ActionCreators.js